import React from "react";
import { motion } from "framer-motion";
import { Home, GraduationCap, Baby, Accessibility, Plane, KeyRound } from "lucide-react";

const cases = [
  { icon: Home, title: "Busy households", desc: "Keep shared items (remotes, car keys, bags) findable for the whole family.", span: "md:col-span-2" },
  { icon: GraduationCap, title: "Students in dorms", desc: "Never lose your ID card, charger pouch, or laptop sleeve in the morning rush." },
  { icon: Baby, title: "Parents managing kids' items", desc: "Track the backpack, the lunchbox, the favorite plush — before the meltdown." },
  { icon: Accessibility, title: "Seniors needing simplicity", desc: "A calm, intuitive way to find what's needed — no complicated tech required.", span: "md:col-span-2" },
  { icon: Plane, title: "Travelers and bags", desc: "Give yourself peace of mind on the luggage carousel and in hotel rooms." },
  { icon: KeyRound, title: "Everyday home essentials", desc: "Glasses, wallets, earbuds, medications — the small stuff that runs your day." },
];

const UseCases = () => {
  return (
    <section
      data-testid="usecases-section"
      className="relative py-28 md:py-36 bg-[#FAFAFA]"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.2em] uppercase text-blue-600 font-medium">Use Cases</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
            Made for the people who need it most.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {cases.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`usecase-${i}`}
              className={`group relative bg-white rounded-3xl border border-zinc-200/80 p-7 overflow-hidden hover:-translate-y-1 transition-transform duration-300 ${c.span || ""}`}
            >
              <div className="absolute -right-8 -top-8 w-40 h-40 glow-blue blur-2xl opacity-0 group-hover:opacity-60 transition duration-500" />
              <div className="relative">
                <div className="w-11 h-11 rounded-2xl bg-zinc-100 flex items-center justify-center">
                  <c.icon className="w-5 h-5 text-zinc-700" strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold tracking-tight">{c.title}</h3>
                <p className="mt-2 text-zinc-600 text-sm leading-relaxed">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
